"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBlockingCallback = void 0;
var react_1 = require("react");
exports.useBlockingCallback = function (callback, delay) {
    var _a = react_1.useState(true), isReady = _a[0], setIsReady = _a[1];
    var _b = react_1.useState(false), toUpdateTimer = _b[0], setToUpdateTimer = _b[1];
    var timerRef = react_1.useRef(null);
    react_1.useEffect(function () {
        setToUpdateTimer(false);
        timerRef.current = setTimeout(function () {
            setIsReady(true);
        }, delay);
        return function () {
            clearTimeout(timerRef.current);
        };
    }, [toUpdateTimer === true]);
    var blockingCallback = function () {
        if (isReady) {
            callback();
            setIsReady(false);
        }
        setToUpdateTimer(true);
    };
    return blockingCallback;
};
